module.exports = __webpack_public_path__ + "img/No record.6b70deb1.png";